import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { SectionLists } from "types";
import JsonSectionCreate from "./JsonSectionCreate";
import KanbanBoard from "./KanbanBoard";
import PreviewImageModal from "./PreviewImageModal";
import { useDispatch } from "react-redux";
import { fetchSectionData } from "../../redux/Slice/jsonDataSlice.js";
import { fetchAdsDropDown } from "../../redux/Slice/adsDropDownSlice.js";
import { fetchClassificationDropDown } from "../../redux/Slice/classificationDropdownSlice.js";
import { fetchCampaignDropDown } from "../../redux/Slice/campaignSlice.js";
import { clearSelections } from "../../redux/Slice/mediaSlice.js";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";

const SectionsList = () => {
  const dispatch = useDispatch();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [currentSection, setCurrentSection] = useState<string | null>(null);
  const [sectionId, setSectionId] = useState<number | null>(null);
  const [previewImage, setPreviewImage] = useState("");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [is_primary, setIs_primary] = useState(false);
  const [loading, setLoading] = useState(true);
  const pageId = localStorage.getItem("pageid");
  const name = localStorage.getItem("pagename");
  const sectionDatasss = useSelector(
    (state: any) => state?.jsondata?.sectionCreateData
  );

  useEffect(() => {
    if (sectionDatasss && sectionDatasss.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [sectionDatasss]);

  const AppUrl = process.env.REACT_APP_IMAGE_URL;

  useEffect(() => {
    dispatch(fetchSectionData());
    dispatch(fetchAdsDropDown());
    dispatch(fetchClassificationDropDown());
    dispatch(fetchCampaignDropDown());
  }, []);

  useEffect(() => {
    if (currentSection) {
      const dataFromJson = sectionDatasss?.find(
        (section) => section.section_name === currentSection
      );
      if (dataFromJson) {
        setPreviewImage(dataFromJson.previewSection);
      }
    }
  }, [currentSection]);

  const openCreateModal = (section: SectionLists, is_primary: boolean) => {
    setSectionId(section.section_id);
    setIs_primary(is_primary);
    setCurrentSection(section.section_name);
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setIsPreviewModalOpen(false);
    setModalIsOpen(false);
    setCurrentSection(null);
  };
  const openPreviewModal = (section: any) => {
    setIsPreviewModalOpen(true);
    setCurrentSection(null);
    setPreviewImage(`${AppUrl}${section.previewSection}`);
  };

  const [showScrollNotification, setShowScrollNotification] =
    React.useState(true);

  const handleScroll = (e) => {
    const { scrollTop } = e.target;
    if (scrollTop > 20) {
      setShowScrollNotification(false);
    } else {
      setShowScrollNotification(true);
    }
  };

  return (
    <>
      <section className="d-flex flex-nowrap justify-content-between">
        <div
          className="col-lg-7 col-md-7"
          style={{
            height: "70vh",
            overflowY: "auto",
            padding: "10px",
            position: "relative",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            flexShrink: 1,
          }}
          onScroll={handleScroll}
        >
          {showScrollNotification && (
            <Box
              sx={{
                position: "absolute",
                bottom: 10,
                left: "50%",
                transform: "translateX(-50%)",
                color: "white",
                padding: "6px 12px",
                fontSize: "14px",
                zIndex: 9,
                borderRadius: "5px",
                opacity: 0.8,
                transition: "opacity 0.3s ease-in-out",
                backgroundColor: "#1976d2",
              }}
            >
              <Typography variant="body2">Scroll down for more</Typography>
            </Box>
          )}

          {loading ? (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-3">
              {[...Array(6)].map((_, index) => (
                <div className="col" key={index}>
                  <Skeleton variant="rectangular" width="100%" height={200} />
                </div>
              ))}
            </div>
          ) : (
            <div className="row row-cols-1 row-cols-md-1 row-cols-lg-2 g-3">
              {sectionDatasss?.map((section, index) => (
                <div className="col" key={index}>
                  <Card
                    sx={{
                      position: "relative",
                      overflow: "hidden",
                      height: "100%",

                      "&:hover .hover-overlay": {
                        opacity: 1,
                        transform: "translateY(0) !important",
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={`${AppUrl}${section.previewSection}`}
                      onClick={() => openPreviewModal(section)}
                      alt="media"
                      sx={{
                        height: 170,
                        objectFit: "contain",
                        backgroundColor: "#f5f5f5",
                        transition: "filter 0.3s ease",
                      }}
                    />
                    <CardContent>
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontWeight: 500,
                          padding: "8px",
                          color: "#333",
                          backgroundColor: "#f5f5f5",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {section?.section_name
                          ?.replace(/_/g, " ")
                          .replace(/section/i, "Section")
                          .replace(/(\d+)/, (match) => ` ${match}`)
                          .trim()}
                      </Typography>
                    </CardContent>

                    <Box
                      className="hover-overlay"
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        background: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        justifyContent: "center",
                        gap: "15px",
                        padding: "12px",
                        opacity: 0,
                        transition:
                          "opacity 0.4s ease, transform 0.4s ease !important",
                        transform: "translateY(100%) !important",
                        zIndex: 3,
                      }}
                    >
                      <Tooltip title="Add section" arrow>
                        <FontAwesomeIcon
                          icon={faSquarePlus}
                          style={{
                            color: "white",
                            fontSize: "20px",
                            cursor: "pointer",
                            padding: "8px",
                            transition: "0.3s ease",
                          }}
                          onClick={() => {
                            openCreateModal(section, section?.is_primary);
                            dispatch(clearSelections());
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.color = "green")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.color = "white")
                          }
                        />
                      </Tooltip>
                    </Box>
                  </Card>
                </div>
              ))}
            </div>
          )}
        </div>{" "}
        <div
          className="col-lg-5 col-md-5"
          style={{
            minWidth: "350px",
            flexShrink: 0,
          }}
        >
          <KanbanBoard
            name={name}
            pageid={pageId}
            modalIsOpen={modalIsOpen}
            sectionImages={sectionDatasss}
          />
        </div>
      </section>

      {modalIsOpen ? (
        <JsonSectionCreate
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          sectionName={currentSection}
          section_id={sectionId}
          is_primary={is_primary}
        />
      ) : null}
      <PreviewImageModal
        isOpen={isPreviewModalOpen}
        onRequestClose={() => setIsPreviewModalOpen(false)}
        previewImagePath={previewImage}
      />
    </>
  );
};

export default SectionsList;
